import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import usePrevious from 'lib/src/hooks/usePrevious';
import { useHistory } from 'react-router-dom';
import { deleteContactUsMessage } from '@actions/contactUsMessages';
import {
    getContactUsMessagesDeleteError,
    getContactUsMessagesIsDeleting,
} from '@selectors/contactUsMessages';

export default function useDeleteContactUsMessage(id: number): UseDeleteContactUsMessageReturn {
    const dispatch = useDispatch();
    const history = useHistory();

    const handleSubmit = useCallback(() => {
        dispatch(deleteContactUsMessage(id));
    }, [dispatch, id]);

    const isDeleting = useSelector(getContactUsMessagesIsDeleting);
    const deleteError = useSelector(getContactUsMessagesDeleteError);
    const wasDeleting = usePrevious(isDeleting);

    useEffect(() => {
        if (wasDeleting && !isDeleting) {
            history.replace('/contact-us-messages');
        }
    }, [isDeleting, wasDeleting, history]);

    return {
        handleSubmit,
        isDeleting,
        deleteError,
    };
}

interface UseDeleteContactUsMessageReturn {
    handleSubmit: () => void;
    isDeleting: boolean;
    deleteError: string | null;
}
